import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <span style={{ fontSize: '20px' }}>
            To find out more about The JD Foundation’s chosen charities and the work it has
            undertaken to help those in need, please read the brochure below.
        </span>
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/jd-foundation-charity-brochure-18-19.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="foundation/charity-brochure.png" />
                    Charity Brochure
                </a>
            </li>
        </ul>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/jd-foundation-brochure.jpg',
    body: Body,
};
